<template>
  <city-blank-form
    submit-label="Сохранить"
    v-bind="$attrs"
    form-type="edit"
    :errors="errors"
    @submit="processForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { updateCity } from '@/services/city.service'
import cityBlankForm from '@/components/forms/city/CityBlankForm'

export default {
  name: 'city-edit-form',
  components: { cityBlankForm },
  inheritAttrs: false,
  data () {
    return {
      errors: {
        city: {
          id: [],
          name: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processForm () {
      this.updateCity().then((success) => {
        if (success) {
          this.showMsg('Информация о городе была успешно обновлена!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    updateCity () {
      return updateCity(this.$attrs.city).then((response) => {
        this.fillErrors(this.errors.city, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.city, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// CityEditForm.vue?6e4d08fc